<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.filterData.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model.trim="searchForm.filterData.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="更新时间">
            <form-date-range :form="searchForm.filterData" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="selectby">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :height="maxTableHeight"
        ref="table"
        border
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column fixed label="图片" width="80" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.imgUrlList.length" size="mini" type="text" @click="viewImg(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" fixed prop="productCode" label="产品编码"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" fixed prop="productName" label="产品名称"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="产品供应商"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="retailPrice" label="基础零售价"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="updateDate" label="更新时间"></el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="text" @click="lookRecord(scope.row)">查看调整记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            background
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 调整记录弹窗 -->
    <adjustment-record-dialog :visible.sync="dialogFormVisible" :row="selectedRow" v-if="dialogFormVisible" />
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close>
      <imgShow :imgList="imgList"></imgShow>
    </el-dialog>
  </content-panel>
</template>

<script>
import imgShow from '@/views/components/imgShow';
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import AdjustmentRecordDialog from './adjustment-record-dialog.vue';

export default {
  name: 'ProductPrice',
  components: { imgShow, AdjustmentRecordDialog },
  mixins: [pagePathMixin, tableMixin],
  data() {
    return {
      loading: false,
      searchForm: {
        filterData: {
          productCode: '',
          productName: '',
          startTime: '',
          endTime: '',
        },
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      selectedRow: {},
      dialogFormVisible: false,
      imgFormVisible: false,
      imgList: [],
    };
  },
  computed: {},
  methods: {
    selectby() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.onSearch();
    },
    lookRecord(row) {
      this.selectedRow = row;
      this.dialogFormVisible = true;
    },
    onSearch() {
      this.loading = true;
      this.searchForm.pageNum = this.tableData.pageNum;
      this.searchForm.pageSize = this.tableData.pageSize;
      this.searchForm.exportTag = false;
      this.$q.product
        .produtPriceListPage({ data: JSON.stringify(this.searchForm) })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initSearchForm() {
      this.searchForm = {
        filterData: {
          productCode: '',
          productName: '',
          startTime: '',
          endTime: '',
        },
      };
    },
    resetForm() {
      this.initSearchForm();
      this.selectby();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 2147483647;
      this.searchForm.exportTag = true;
      let params = {
        appCode: "ec-pc-api",
        paramMap: {
          ...this.searchForm.filterData,
        },
        reportName: "productPriceExport",
      };
      console.log(this.searchForm);
      console.log("params", params);

      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=> {
        loading.close()
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 查看图片
    viewImg(row) {
      this.imgFormVisible = true;
      this.imgList = [];
      const list = row.imgUrlList;
      for (const item of list) {
        this.imgList.push(item.path);
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 200px !important

>>> .date-range .single-date
  width 110px !important

.dialog-el-form >>> .el-form-item
  margin-bottom 0
</style>
